<template>
  <div class="tripadvisor-score-component flex items-center space-x-2 -ml-2">
    <img
      :src="`https://www.tripadvisor.com/img/cdsi/img2/ratings/traveler/${rating.toFixed(1)}-MCID-5.svg`"
    />
  </div>
</template>

<script>
export default {
  props: {
    rating: {
      type: Number,
      default: 3.5,
    },
  },
};
</script>
